import type { AuthProviderProps } from 'react-oidc-context';

import { env } from '@/lib/env';

/**
 * react-oidc-context configuration for the SafarAPI Console.
 * Realm + client created via `docs/safarapi-keycloak-realm.md` (k3s-infra runbook).
 */
export const oidcConfig: AuthProviderProps = {
    authority: `${env.keycloakUrl}/realms/${env.keycloakRealm}`,
    client_id: env.keycloakClientId,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: window.location.origin,
    response_type: 'code',
    // Only `openid` — the `safarapi-console` client does not list `profile` /
    // `email` in its client scopes, so requesting them explicitly is rejected
    // with `invalid_scope`. The profile claims (given_name, family_name, email,
    // preferred_username) ride on the `partner_attributes` default client scope
    // instead, via its protocol mappers in the realm config.
    scope: 'openid',
    automaticSilentRenew: true,
    loadUserInfo: false,
    onSigninCallback: () => {
        // Strip the code/state query string after the token exchange. The actual
        // redirect from /auth/callback to / is performed by the AuthCallback
        // component once `isAuthenticated` flips to true (via React Router).
        window.history.replaceState({}, document.title, window.location.pathname);
    },
};
